import React from 'react'

import ProductForm from './components/ProductForm'
import ProductList from './components/ProductList'

const Product: React.FC = () => {
  return (
    <div className="row">
      <ProductForm />
      <ProductList />
    </div>
  )
}

export default Product
